import { LucideProps } from 'lucide-react';

export const RupeeSign = ({ size = 24, ...props }: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 3h12M6 8h12M6 13l8.5 8M15 8c0 4-6 4-6 4" />
  </svg>
);

export default RupeeSign; 